/**
 * CNESHeader Component - Page header with back button
 */
import React from 'react';
import { ArrowLeft, Building2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const CNESHeader: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="mb-8">
      <button
        onClick={() => navigate('/selection-client')}
        className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-4 transition-colors"
      >
        <ArrowLeft className="w-5 h-5" />
        Voltar
      </button>

      <div className="flex items-center gap-4">
        <div className="w-16 h-16 bg-green-100 rounded-lg flex items-center justify-center">
          <Building2 className="w-8 h-8 text-green-600" />
        </div>
        <div>
          <h1 className="text-3xl font-bold text-gray-900">
            Consulta Hospitais CNES
          </h1>
          <p className="text-gray-600">
            Cadastro Nacional de Estabelecimentos de Saúde
          </p>
        </div>
      </div>
    </div>
  );
};
